// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2ibOS","range":"MonthRangeSwitch_range__cHHnC","disabled":"MonthRangeSwitch_disabled__2fgel"};